var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('OmniButtonCollection', _vm._b({}, 'OmniButtonCollection', [_vm.$attrs, _vm.$props], false), [_c('OmniButton', {
    attrs: {
      "disabled": _vm.dispatchRequestRerouteMode,
      "spin": _vm.isDispatchRequestsLoading,
      "icon": "sync-alt",
      "size": "lg",
      "variant": "info"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('reloadDispatchRequests');
      }
    }
  }, [_vm._v(" Vernieuwen ")]), _vm.hasAllPermissions(['orders.dispatchrequests.reroute', 'orders.dispatchrequests.reroute.showbutton']) && _vm.hasReroutableDispatchRequests ? _c('OmniButton', {
    class: {
      'text-secondary': !_vm.dispatchRequestRerouteMode,
      'text-primary': _vm.dispatchRequestRerouteMode
    },
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "icon": "route",
      "size": "lg"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggleRerouteMode');
      }
    }
  }, [_vm._v(" " + _vm._s((_vm.dispatchRequestRerouteMode ? 'Verlaat' : 'Ga naar') + ' reroute mode') + " ")]) : _vm._e(), _vm.canAddOrderLines ? _c('OmniButton', {
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "icon": "circle-plus",
      "size": "lg"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openFinalDispatchRequestActionModal', 'add-extra-order-lines');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.add-extra-order-lines')) + " ")]) : _vm._e(), _vm.hasPermission('orders.addorderline') ? _c('OmniButton', {
    staticClass: "text-warning",
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "size": "lg",
      "icon": "circle-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('showModal', 'add-order-line-modal');
      }
    }
  }, [_vm._v(" Orderregel toevoegen ")]) : _vm._e(), _vm.canInspectMetadata ? _c('OmniButton', {
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "icon": "glasses",
      "size": "lg"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('showModal', 'inspect-dispatch-request-metadata-modal');
      }
    }
  }, [_vm._v(" Bekijk ruwe data ")]) : _vm._e(), _vm.canCreateShippedWithIssues ? _c('OmniButton', {
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "icon": "far fa-frown",
      "variant": "danger",
      "size": "lg"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openFinalDispatchRequestActionModal', 'create-shipped-with-issues');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.create-shipped-with-issues')) + " ")]) : _vm._e(), _vm.canCancelLines ? _c('OmniButton', {
    attrs: {
      "disabled": _vm.isDispatchRequestsLoading,
      "icon": "ban",
      "variant": "danger",
      "size": "lg"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openFinalDispatchRequestActionModal', 'cancel-multiple-lines');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.cancel-multiple-lines')) + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }